import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import _ from 'lodash';
import React from 'react';
import ListingBadge, { BADGE_ORDER_PRIORITY, BADGE_MODE } from './base';
import { getBrokerAgent, isREO, isShortSale, isForeclosure } from './utils';
class InteriorAccessAvailableBadge extends ListingBadge {
    static title = 'Interior Access';
    static titleIcon = 'unlock-alt';
    static condensedTitleIcon = 'door-open';
    static renderPriority = BADGE_ORDER_PRIORITY.THIRD;
    static titleV2 = this.title;
    static renderPriorityV2 = () => BADGE_ORDER_PRIORITY.FIFTH;
    static shouldBeIncluded(listing) {
        const brokerAgent = getBrokerAgent(listing);
        return (_.get(listing, 'listing_configuration.interior_access_allowed', false) &&
            _.isPlainObject(brokerAgent) &&
            (isREO(listing) || isShortSale(listing)));
    }
    static shouldBeIncludedV2(listing) {
        return this.shouldBeIncluded(listing) && !isForeclosure(listing);
    }
    get content() {
        const brokerAgent = getBrokerAgent(this.props.listing) || {};
        return (_jsxs(_Fragment, { children: ["Access is available through the listing agent ", brokerAgent.party_name, ' ', _jsx("a", { onClick: e => this.emitEvent('interior_access_contact_agent', e), "data-elm-id": 'interior_access_contact_agent', children: "Contact Agent" }), "."] }));
    }
}
class InteriorAccessAvailableNoAgentBadge extends ListingBadge {
    static title = 'Interior Access';
    static titleIcon = 'unlock-alt';
    static condensedTitleIcon = 'door-open';
    static renderPriority = BADGE_ORDER_PRIORITY.THIRD;
    static titleV2 = this.title;
    static renderPriorityV2 = () => BADGE_ORDER_PRIORITY.FIFTH;
    static shouldBeIncluded(listing) {
        const brokerAgent = getBrokerAgent(listing);
        return (_.get(listing, 'listing_configuration.interior_access_allowed', false) &&
            !brokerAgent &&
            (isREO(listing) || isShortSale(listing)));
    }
    static shouldBeIncludedV2(listing) {
        return this.shouldBeIncluded(listing) && !isForeclosure(listing);
    }
    get content() {
        return (_jsxs(_Fragment, { children: ["Licensed agents only, please contact", ' ', _jsx("a", { href: 'tel:8008410607', children: "(800) 841-0607" }), " for details."] }));
    }
}
class InteriorAccessUnavailableBadge extends ListingBadge {
    static title = 'Interior Access';
    static titleIcon = 'unlock-alt';
    static summary = 'No';
    static contentPositive = false;
    static content = 'Interior access is not available for this property.';
    static shouldBeIncluded(listing, badgeMode) {
        return (badgeMode === BADGE_MODE.EXPANDED &&
            !_.get(listing, 'listing_configuration.interior_access_allowed', false) &&
            (isREO(listing) || isShortSale(listing)));
    }
}
export { InteriorAccessAvailableBadge, InteriorAccessAvailableNoAgentBadge, InteriorAccessUnavailableBadge, };
//# sourceMappingURL=interiorAccess.js.map